import en from "./en"
import bg from "./bg"
import keysList from "./keys"

function translate(key, locale) {
  return locale === "bg" ? bg[key] : en[key]
}

export default translate
export const keys = keysList
